import { StripeConnectTab } from './StripeConnectTab.tsx';

export default function Payouts() {
  return (
    <div className="container mx-auto py-6 space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Payouts</h1>
        <p className="text-muted-foreground">
          Connect your Stripe account to receive commission payouts
        </p>
      </div>

      <StripeConnectTab />
    </div>
  );
}
